import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

const STORAGE_KEY = "cookieNotice";

const CookieNotice = () => {
  const [choice, setChoice] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "";
    } catch (error) {
      return "";
    }
  });

  if (choice) return null;

  const save = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      /* el aviso vuelve a mostrarse si el navegador bloquea el almacenamiento */
    }
    setChoice(value);
  };

  return (
    <aside
      role="dialog"
      aria-label="Cookies y privacidad"
      style={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1400,
        maxWidth: 520,
        margin: "0 auto",
        background: "#ffffff",
        color: "#0f172a",
        borderRadius: 18,
        padding: "18px 18px 16px",
        boxShadow: "0 18px 50px rgba(15,23,42,0.18)",
        border: "1px solid rgba(15,23,42,0.06)",
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 8 }}>
        <span aria-hidden="true" style={{ fontSize: 22 }}>🍪</span>
        <strong style={{ fontSize: 16 }}>Cookies y privacidad</strong>
      </div>
      <p style={{ margin: "0 0 14px", fontSize: 14, lineHeight: 1.5, color: "#334155" }}>
        Usamos cookies necesarias para que el sitio funcione y para mantener tu sesión.
        No usamos cookies de publicidad.{" "}
        <RouterLink to="/privacidad#cookies" style={{ color: "#2563eb", fontWeight: 700 }}>
          Más información.
        </RouterLink>
      </p>
      <div style={{ display: "flex", gap: 10 }}>
        <button
          type="button"
          onClick={() => save("accepted")}
          style={{
            flex: 1,
            height: 44,
            border: 0,
            borderRadius: 12,
            background: "#4f46e5",
            color: "#fff",
            fontWeight: 800,
            cursor: "pointer",
          }}
        >
          Aceptar
        </button>
        <button
          type="button"
          onClick={() => save("rejected")}
          style={{
            flex: 1,
            height: 44,
            borderRadius: 12,
            border: "1px solid rgba(15,23,42,0.12)",
            background: "#fff",
            color: "#0f172a",
            fontWeight: 800,
            cursor: "pointer",
          }}
        >
          Rechazar
        </button>
      </div>
    </aside>
  );
};

export default CookieNotice;
